import React from 'react';
import './npsQuestion.sass';

const CESQuestion = ({ question, value, onChange, user }) => {
  const isSevenScale = question.questionType === 'CUSTOMER_EFFORT_SCORE_0_7';

  const cesOptions = isSevenScale
    ? [
        { value: '1', label: 'Very Easy', emoji: '😄', className: 'positive-nps' },
        { value: '2', label: 'Easy', emoji: '🙂', className: 'positive-nps' },
        { value: '3', label: 'Somewhat Easy', emoji: '🙂', className: 'positive-nps' },
        { value: '4', label: 'Neither', emoji: '😐', className: 'neutral-nps' },
        { value: '5', label: 'Somewhat Difficult', emoji: '😟', className: 'negative-nps' },
        { value: '6', label: 'Difficult', emoji: '😟', className: 'negative-nps' },
        { value: '7', label: 'Very Difficult', emoji: '😡', className: 'negative-nps' },
      ]
    : [
        { value: '1', label: 'Very Easy', emoji: '😄', className: 'positive-nps' },
        { value: '2', label: 'Easy', emoji: '🙂', className: 'positive-nps' },
        { value: '3', label: 'Neither', emoji: '😐', className: 'neutral-nps' },
        { value: '4', label: 'Difficult', emoji: '😟', className: 'negative-nps' },
        { value: '5', label: 'Very Difficult', emoji: '😡', className: 'negative-nps' },
      ];

  function handleScore(event) {
    const selectedValue = event.target.value;

    const selectedOption = cesOptions.find((option) => option.value === selectedValue);

    onChange(
      {
        value: selectedValue,
        text: selectedOption?.label || '',
      },
      question.questionID,
      question.questionLevel,
    );
  }

  const questionText = question.questionText.replace(/\{user\}/gi, user);

  return (
    <div className="nps-container">
      <h4 className="range-score-question">
        <p className="question-text" dangerouslySetInnerHTML={{ __html: questionText }} />
      </h4>

      <div className="nps-form">
        <ul className="scale-container">
          {cesOptions.map((option) => (
            <div key={option.value}>
              <label
                className={value === option.value ? `active ${option.className}` : option.className}
              >
                <input
                  type="radio"
                  name={`CES-${question.questionID}`}
                  value={option.value}
                  checked={value === option.value}
                  onChange={handleScore}
                  style={{ display: 'none' }}
                />
                <span>{option.value}</span>
              </label>

              <div>{option.emoji}</div>
            </div>
          ))}
        </ul>

        <div className="scale-indicator">
          <span style={{ color: 'green' }}>Very Easy</span>
          <span style={{ color: 'red' }}>Very Difficult</span>
        </div>
      </div>
    </div>
  );
};

export default CESQuestion;
